const TXT_EXTENSION = 'txt';

export {
  TXT_EXTENSION
}
